module.exports = __webpack_public_path__ + "static/media/galeryAntihumidity5.0f37792f.jpg";